import { put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  GET_WISHLIST_DATA,
  PRODUCT_WISHLIST_ADD,
  PRODUCT_WISHLIST_REMOVE,
} from "../SagaAction/actions";
import {
  getWishListDataFailure,
  getWishListDataRequest,
  getWishListDataSuccess,
  userWishlistAddFailure,
  userWishlistAddRequest,
  userWishlistAddSuccess,
  userWishlistRemoveFailure,
  userWishlistRemoveRequest,
  userWishlistRemoveSuccess,
} from "../Slices/WishListSlice";
import requestApi from "../../utils/request";

function* getWishList() {
  try {
    yield put(getWishListDataRequest());
    const { data } = yield requestApi.post("/product/wishlist");// Create an array of image loading promises
   
    yield put(getWishListDataSuccess(data));
  } catch (error) {
    yield put(getWishListDataFailure(error));
  }
}

// Added WishList H
function* userProductWishListADD(params) {
  console.log(params.payload, "HIREN");
  try {
    yield put(userWishlistAddRequest());
    const { meta } = yield requestApi.post(
      "product/add-wishlist",
      params.payload
    );
    yield put(userWishlistAddSuccess(meta));
      if(typeof params.callback === "function"){
        yield params.callback(meta?.message)
      }
  } catch (e) {
    yield put(userWishlistAddFailure(e));
  }
}
//Remove WishList H
function* userProductWishListREMOVE(params) {
  try {
    yield put(userWishlistRemoveRequest());
    const {meta} = yield requestApi.post(
      "product/remove-wishlist",
      params.payload
    );
    yield put(userWishlistRemoveSuccess(meta));
    if(typeof params?.callback === "function"){
        yield params?.callback(meta?.message)
    }
  } catch (e) {
    yield put(userWishlistRemoveFailure(e));
  }
}

function* WishListSaga() {
  yield takeEvery(GET_WISHLIST_DATA, getWishList);
  yield takeEvery(PRODUCT_WISHLIST_ADD, userProductWishListADD);
  yield takeEvery(PRODUCT_WISHLIST_REMOVE, userProductWishListREMOVE);
}

export default WishListSaga;
